import React from 'react';
import '../../App.css';
import HomeItem from '../HomeItem';

function LikedPlaces() {
    return (
        <>
        <br /><br /><br />
        <div className='container'>
        <center><h3 className='subheader green-text'>Liked Places</h3></center>
        <br /><br /><br />
            <div className='row'>
                <HomeItem src='./images/img-9.jpg' name="Studio apartment - Nicon estate" bed="2" bath="2" amount="1,500,000" likes='31' />
                <HomeItem src='./images/img-9.jpg' name="Studio apartment - Nicon estate" bed="2" bath="2" amount="1,500,000" likes='31' />
                <HomeItem src='./images/img-9.jpg' name="Studio apartment - Nicon estate" bed="2" bath="2" amount="1,500,000" likes='31' />

            </div>
        </div></>
        
        
    )
}

export default LikedPlaces;